import React from 'react';
import { GlobalDesignGroupActionPanel } from '../types';
import { useGlobalDesignStyles } from '../common/abstractStyles/useGlobalDesignStyles';

import { useTranslation } from '../..';
import { GLOBAL_DESIGN_TRANSLATION_KEYS } from '../constants';

const StrokeControls = React.lazy(() => import('./StrokeControls'));

const StrokeStyles: GlobalDesignGroupActionPanel = (props) => {
  const [t] = useTranslation();
  const { values, updateStyles, isLoading, sdkClient } = useGlobalDesignStyles(
    props.host,
    'strokeStyles',
    props.componentsAPI,
    { withVariablesResolution: true },
  );

  if (isLoading || !values || !sdkClient) {
    return <div>{t(GLOBAL_DESIGN_TRANSLATION_KEYS.LOADING)}</div>;
  }

  return (
    <StrokeControls
      sdkClient={sdkClient}
      metadata={props.group.metadata}
      values={values}
      updateStyles={updateStyles}
    />
  );
};

export default StrokeStyles;
